/**
 * Main JavaScript entry point for THS Theme
 * Handles global functionality and utilities
 */

// Import main styles
import '../scss/main.scss'

// Import legacy JavaScript (Elementor compatibility - to be removed when Elementor is deprecated)
import './legacy'

// Import utilities
import { initializeTheme } from './utilities/smooth-scroll'
import { initTabs } from './utilities/tabs'
import { initOffCanvasMenu, closeOffCanvasMenu } from './utilities/menu-mobile'
import { initSearchAccordion } from './utilities/search-accordion'
import { initWcTables, initWcTablesCartObserver } from './utilities/wc-tables'
import { handleContactForms } from './utilities/forms'
import { initHorizontalScroller } from './utilities/horizontal-scroller'
import './utilities/menu-desktop' // Auto-initializes on desktop
// TODO: These utilities need proper HTML structure and CSS implementation before activation
// import { setupAccessibility } from './utilities/accessibility' // Needs: .skip-link, #main-content, modal structure

// Expose public API on window object for cross-module communication
window.THSTheme = {
  closeOffCanvasMenu
}

// Initialize theme when DOM is ready
// Note: Script is loaded with defer attribute, so DOM is already ready when this executes
// If defer wasn't used, we'd need to check document.readyState or use DOMContentLoaded

if (document.readyState === 'loading') {
  // DOM not ready yet, wait for it
  document.addEventListener('DOMContentLoaded', initializeApp)
} else {
  // DOM is already ready (script loaded with defer or async)
  initializeApp()
}

function initializeApp() {
  initializeTheme()
  initTabs()
  initOffCanvasMenu()
  initSearchAccordion()
  initWcTables()
  initWcTablesCartObserver()
  handleContactForms()
  initHorizontalScroller()

  // TODO: Uncomment when supporting HTML structure is implemented
  // setupAccessibility()

  // Initialize blocks (ACF Flexible Content blocks)
  // Block-specific functionality will be added here as needed
}

// Handle module hot replacement for development
if (module.hot) {
  module.hot.accept()
}
